export interface SamplePromptGroup {
    header: string;
    prompts: string[];
}

export const SAMPLE_PROMPTS: SamplePromptGroup[] = [
    {
        header: 'DETAILS',
        prompts: [
            'Find part details for JAN2N2222A manufactured by MICROCHIP TECHNOLOGY',
            'What is the Response Time for LM311J from Rochester?',
            'What is the COO of VTVS25GSMF-M3-18?'
        ]
    },
    {
        header: 'COMPARISON',
        prompts: [
            'Can you contrasts the features of 7P36FLV562I15 and 7P36FLV571C25 from Microchip',
            'Compare 742X083102JP from CTS Corp and BCN164A102J7 TT Electronics'
        ]
    },
    {
        header: 'ALTERNATE PARTS',
        prompts: ['Find alternates for the part RMCF0603FT82K5', 'Find alternates for IS62C256AL-45ULI']
    },
    {
        header: 'TECHNICAL PARAMETERS',
        prompts: [
            'Show me Fixed Inductors parts that are not made in China, Canada or Mexico',
            'Suggest a good resistor part number with 9310 ohms, 1% tolerance, 100 PPM, and 0.1W',
            'Find parts with the following characteristics: 0.063W, 1000ohm, 50V resistor'
        ]
    }
    // Commented by Dhiraj request 04.24.25
    // 'Find alternate parts for 2N2219A'
];
